import type { IToolsState } from './types';

export const state: IToolsState = {
  annotations: [],
};
